if (document.querySelectorAll("#our-story-lottie-covid19-right").length) {
  window.bodymovin.loadAnimation({
    container: document.getElementById("our-story-lottie-covid19-right"), // Required
    path: "assets/animations/covid-19-right.json", // Required
    renderer: "canvas", // Required
    loop: true,
    autoplay: true,
    name: "our-story-intro",
  });
}
if (document.querySelectorAll("#our-story-lottie-covid19-left").length) {
  window.bodymovin.loadAnimation({
    container: document.getElementById("our-story-lottie-covid19-left"), // Required
    path: "assets/animations/covid-19-left.json", // Required
    renderer: "canvas", // Required
    loop: true,
    autoplay: true,
    name: "our-story-intro",
  });
}

// Disable for Mobile
if (window.screen.width > 640) {
  if (document.querySelectorAll("#our-story-lottie-hpv-right").length) {
    window.bodymovin.loadAnimation({
      container: document.getElementById("our-story-lottie-hpv-right"), // Required
      path: "assets/animations/hpv-right.json", // Required
      renderer: "canvas", // Required
      loop: true,
      autoplay: true,
      name: "our-story-intro",
    });
  }
  if (document.querySelectorAll("#our-story-lottie-hpv-left").length) {
    window.bodymovin.loadAnimation({
      container: document.getElementById("our-story-lottie-hpv-left"), // Required
      path: "assets/animations/hpv-left.json", // Required
      renderer: "canvas", // Required
      loop: true,
      autoplay: true,
      name: "our-story-intro",
    });
  }
}

if (document.querySelectorAll("#our-story-lottie-food-industry-right").length) {
  window.bodymovin.loadAnimation({
    container: document.getElementById("our-story-lottie-food-industry-right"), // Required
    path: "assets/animations/foodindustry-right.json", // Required
    renderer: "canvas", // Required
    loop: true,
    autoplay: true,
    name: "our-story-intro",
  });
}

if (document.querySelectorAll("#our-story-lottie-food-industry-left").length) {
  window.bodymovin.loadAnimation({
    container: document.getElementById("our-story-lottie-food-industry-left"), // Required
    path: "assets/animations/foodindustry-left.json", // Required
    renderer: "canvas", // Required
    loop: true,
    autoplay: true,
    name: "our-story-intro",
  });
}

if (document.querySelectorAll("#our-story-lottie-seachange-right").length) {
  window.bodymovin.loadAnimation({
    container: document.getElementById("our-story-lottie-seachange-right"), // Required
    path: "assets/animations/seachange-right.json", // Required
    renderer: "canvas", // Required
    loop: true,
    autoplay: true,
    name: "our-story-intro",
  });
}

if (document.querySelectorAll("#our-story-lottie-seachange-left").length) {
  window.bodymovin.loadAnimation({
    container: document.getElementById("our-story-lottie-seachange-left"), // Required
    path: "assets/animations/seachange-left.json", // Required
    renderer: "canvas", // Required
    loop: true,
    autoplay: true,
    name: "our-story-intro",
  });
}

if (document.querySelectorAll("#our-story-lottie-young-right").length) {
  window.bodymovin.loadAnimation({
    container: document.getElementById("our-story-lottie-young-right"), // Required
    path: "assets/animations/youthprogrammes-right.json", // Required
    renderer: "canvas", // Required
    loop: true,
    autoplay: true,
    name: "our-story-intro",
  });
}

if (document.querySelectorAll("#our-story-lottie-young-left").length) {
  window.bodymovin.loadAnimation({
    container: document.getElementById("our-story-lottie-young-left"), // Required
    path: "assets/animations/youthprogrammes-left.json", // Required
    renderer: "canvas", // Required
    loop: true,
    autoplay: true,
    name: "our-story-intro",
  });
}
